export const getYearDateRange = (year: number | string) => {
  if (typeof year !== "number") {
    if (year === "all") {
      const futureYear = new Date().getFullYear() + 5;
      return {
        firstDay: "2017-01-01",
        lastDay: `${futureYear}-12-31`,
      };
    } else {
      year = parseInt(year);
    }
  }
  const firstDay = `${year}-01-01`; // First day of the year
  const lastDay = `${year}-12-31`; // Last day of the year
  return { firstDay, lastDay };
};
